import React from 'react';
import PropTypes from 'prop-types';

/**
 * CourseInfoBar - Kompakte Kurs-Info Leiste
 * 
 * Zeigt Kurs-Icon, Name, Beschreibung und Stats in einer Zeile.
 * Verwendet für CourseView2 Header-Bereich.
 * 
 * Usage:
 * <CourseInfoBar
 *   icon="📚"
 *   name="Frontend-Entwicklung"
 *   description="JavaScript, React und moderne Webentwicklung"
 *   color="#3B82F6"
 *   stats={[
 *     { value: 5, label: 'Vorlagen' },
 *     { value: 2, label: 'aktive Sessions' }
 *   ]}
 * />
 */
export default function CourseInfoBar({
  icon,
  name,
  description,
  color = '#3B82F6',
  stats = []
}) {
  return (
    <div 
      className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4"
      style={{ borderLeftWidth: '4px', borderLeftColor: color }}
    >
      <div className="flex items-start gap-4">
        {/* Icon */}
        {icon && (
          <div 
            className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center text-2xl"
            style={{ backgroundColor: `${color}20` }}
          >
            {icon}
          </div>
        )}
        
        {/* Content */}
        <div className="flex-1 min-w-0">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white truncate">
            {name}
          </h2>
          {description && (
            <p className="text-sm text-gray-500 dark:text-gray-400 truncate">
              {description}
            </p>
          )}
          
          {/* Stats */}
          {stats.length > 0 && (
            <div className="flex items-center gap-4 mt-2 text-sm text-gray-600 dark:text-gray-400">
              {stats.map((stat, index) => (
                <span key={index} className="flex items-center gap-1">
                  <span className="font-medium text-gray-900 dark:text-white">{stat.value}</span>
                  <span>{stat.label}</span>
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

CourseInfoBar.propTypes = {
  icon: PropTypes.string,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  color: PropTypes.string,
  stats: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    label: PropTypes.string.isRequired
  }))
};
